var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingCart = function SvgShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5.146 12.96c.301 0 .545-.256.545-.573 0-.317-.244-.574-.545-.574-.301 0-.545.257-.545.574 0 .317.244.574.545.574ZM11.146 12.96a.56.56 0 0 0 .545-.573c0-.317-.244-.574-.545-.574-.301 0-.545.257-.545.574 0 .317.244.574.545.574Z",
    stroke: "#E59400",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 .96h2.182L4.644 8.65c.103.546.562.935 1.09.924h5.302c.529.011.988-.378 1.091-.924L13 3.832H3.727",
    stroke: "#E59400",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgShoppingCart;